import React from 'react'
import styles from './Integrations.module.scss'
import { COUNTRY } from '../../../../common/utils/constants'

const isRu = COUNTRY === 'ru'

const items = [
  { label: 'Оплата картами' },
  { label: 'Личные продажи' },
  ...(isRu ? [{ label: 'СБП' }, { label: 'Чеки' }, { label: 'Маркировка' }] : []),
  { label: 'QR каталог' },
]

export const Integrations: React.FC = () => {
  return (
    <div className={styles.grid}>
      {items.map(({ label }) => (
        <div key={label} className={styles.card}>
          <span>{label}</span>
        </div>
      ))}
    </div>
  )
}
